export default __webpack_public_path__ + "static/media/centrica.0a84e4a2.png";